<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="酒店ID" v-bind="searchItemLayout">
            <a-input v-model="queryParams.erpHotelId" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="酒店名称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.hotelName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="已匹配酒店ID" v-bind="searchItemLayout">
            <a-input v-model="queryParams.outerProId" placeholder="请输入"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="匹配状态" v-bind="searchItemLayout" style="margin-bottom: 0">
            <a-select style="width: 100%" v-model="queryParams.matchStatus" placeholder="请选择" allowClear>
              <a-select-option :value="0">待匹配</a-select-option>
              <a-select-option :value="1">已匹配</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-left:10%;margin-bottom: 0">
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
      <a-row type="flex" justify="end" style="margin-bottom: 15px;">
        <a-col :span="12" class="flex-center">
          <span>直连酒店状态：</span>
          <a-switch v-model="isChecked" @change="onSwitchChange" checked-children="开" un-checked-children="关"/>
        </a-col>
      </a-row>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="erpHotelId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <template slot="timeSlots" slot-scope="data">
        <span v-if="data.record.createTime">{{ data.record.createTime }}</span>
        <span v-else>--</span>
      </template>
      <div slot="action" slot-scope="data">
        <span v-if="data.record.matchStatus==1">
          <a @click="goDetails(data.record.erpHotelId,data.record.hotelName)">详情</a>
          <a-divider type="vertical"/>
        </span>
        <a @click="handleUpdata(data.record.erpHotelId,data.record.hotelName)">匹配</a>
      </div>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'hotelDirectList',
  mixins: [searchForm],
  data() {
    return {
      selectedOrderDate: undefined,
      paymentList: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      isChecked: false,
      columns: [
        {
          title: '酒店ID',
          dataIndex: 'erpHotelId'
        },
        {
          title: '酒店名称',
          dataIndex: 'hotelName',
          width: '280px'
        },
        {
          title: '匹配状态',
          dataIndex: 'matchStatusStr'
        },
        {
          title: '已匹配酒店ID',
          dataIndex: 'matchPlatformProId'
        },
        {
          title: '匹配时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'timeSlots' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.getConnStatus()
  },
  activated() {
    // this.getConnStatus();
    // if(this.$route.query.updateFlag){
    //   this.getLogUtils().logWithTag("activated",this.$route.query.updateFlag)
    // }
  },
  methods: {
    //获取是否开启酒店直连
    getConnStatus() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('direct/erpHotel/getErpHotelDirectStatus', params)
        .then(res => {
          this.getLogUtils().logWithTag('getConnStatus', res)
          if (res && res == 1) {
            this.isChecked = true
          } else {
            this.isChecked = false
          }
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSwitchChange(checked) {
      this.getLogUtils().logWithTag('onSwitchChange', checked)
      this.setConnStatus(checked)
    },
    //修改酒店直连值
    setConnStatus(checked) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('direct/erpHotel/editErpHotelDirectStatus', params)
        .then(res => {
          let textStr = checked ? '开启全国直连酒店成功' : '关闭全国直连酒店成功'
          this.$message.success(textStr)
          this.getConnStatus()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      if (this.isChecked) {
        return this.getHttpServices().getCloudProService().post('erp/search/searchErpHotelMatchList', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }

    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    goDetails(proId, proName) {
      this.getLogUtils().logWithTag('record==', proId)
      this.$router.push({
        name: 'HotelMatchDetail',
        query: {
          proId: proId,
          proName: proName,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    handleUpdata(proId, proName) {
      this.getLogUtils().logWithTag('record==', proId)
      this.$router.push({
        name: 'HotelhandleMatch',
        query: {
          proId: proId,
          proName: proName,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }

}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.flex-center {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

</style>